module.exports = __webpack_public_path__ + "img/yancao_shifang_1.8e9876f6.png";